/**
 * @fileOverview 半角英数記号をspanで囲むよ
 *
 * @author koyanagi@bulanco.net(Akihiro Koyanagi)
 * @version 1.0.0
 *
 */
 
 /**
 * @param {jQueryObject} $elm
 * 
 * @param {String} className spanのClassName
 * 
 * @param {String} range 'all' or 'number' or 'alph' or 'symbol'
 *     'all' 半角英数記号(default)
 *     'number' 半角数字のみ
 *     'alph' 半角アルファベットのみ
 *     'symbol' 半角記号のみ
 * 
 * @example
 * $(".blog-content")内のhtml中で半角数字のみ<span class="hankakuNum">で囲む
 * wrapSingleByteTexts($(".blog-content"), 'hankakuNum', 'number');
 * 
 */
function wrapSingleByteTexts($elm, className, range){
	
	var wrapTag = '<span class="'+className+'">';
	var wrapTag_end = '</span>';
	var isTag = false;
	var isHan = false;
	var isStyle = false;
	
	var re;
	switch(range){
		default:
			re = new RegExp(/[\da-z\.\-\!"#\$%&'\(\)=\^~\|@`\[\{\]\}\*\:\+;\?\/\,_\\]/i);
		break;
		case 'number':
			re = new RegExp(/\d/);
		break;
		case 'alph':
			re = new RegExp(/[a-z]/i);
		break;
		case 'symbol':
			re = new RegExp(/[\.\-\!"#\$%&'\(\)=\^~\|@`\[\{\]\}\*\:\+;\?\/\,_\\]/);
		break;
	}
	
	var html = $elm.html();
	html = html.replace(/\s+>/g, '>');
	
	var i;
	for(i=0; i<html.length; i++){

        if (!isTag && html.substring(i, i+7).toLowerCase() === "<style>") {
            isStyle = true;
        }
		
        if (isStyle && html.substring(i, i+8).toLowerCase() === "</style>") {
            isStyle = false;
        }
		
        if (isStyle) {
            continue;
        }

		if (isTag===false){
			if (html[i]=='<'){
				
				isTag = true;
				
				if (isHan===true){
					html = html.substr(0,i)+wrapTag_end+html.substr(i);
					i += wrapTag_end.length;
					isHan = false;
					continue;
				}
				
			}
		} else {
			if (html[i]=='>'){
				isTag = false;
			}
		}
		
		if (isTag===false){
			if (html[i].match(re)){
				if (isHan===false){
					html = html.substr(0,i)+wrapTag+html.substr(i);
					i += wrapTag.length;
				}
				isHan = true;
			} else {
				if (isHan===true){
					html = html.substr(0,i)+wrapTag_end+html.substr(i);
					i += wrapTag_end.length;
				}
				isHan = false;
			}
		}
		
	}
	
	$elm.html(html);

}
